var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 21,
    viewBox: "0 0 33 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/\xED\x94\x84\xEB\xA1\x9C\xEC\xA0\x9D\xED\x8A\xB8\xEB\xAA\xA9\xEB\xA1\x9D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 21V18.5769H16.1538V21H0ZM0 12.5192V10.0962H8.07692V12.5192H0ZM0 4.03846V1.61538H8.07692V4.03846H0ZM30.6115 21L24.15 14.5385C23.45 15.0769 22.6961 15.4808 21.8885 15.75C21.0808 16.0192 20.2462 16.1538 19.3846 16.1538C17.15 16.1538 15.2452 15.3663 13.6702 13.7913C12.0952 12.2163 11.3077 10.3115 11.3077 8.07692C11.3077 5.84231 12.0952 3.9375 13.6702 2.3625C15.2452 0.7875 17.15 0 19.3846 0C21.6192 0 23.524 0.7875 25.099 2.3625C26.674 3.9375 27.4615 5.84231 27.4615 8.07692C27.4615 8.93846 27.3269 9.77308 27.0577 10.5808C26.7885 11.3885 26.3846 12.1423 25.8462 12.8423L32.3077 19.3038L30.6115 21ZM19.3751 13.7308C20.943 13.7308 22.2788 13.182 23.3827 12.0845C24.4865 10.987 25.0385 9.65431 25.0385 8.08641C25.0385 6.51855 24.4897 5.18269 23.3922 4.07885C22.2947 2.975 20.962 2.42308 19.3941 2.42308C17.8262 2.42308 16.4904 2.97184 15.3865 4.06936C14.2827 5.16685 13.7308 6.49954 13.7308 8.06743C13.7308 9.6353 14.2795 10.9712 15.377 12.075C16.4745 13.1788 17.8072 13.7308 19.3751 13.7308Z",
    fill: "#002868"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavProject);
export default __webpack_public_path__ + "static/media/nav-project.b0ef0126a54276fb725954cdea2f58d2.svg";
export { ForwardRef as ReactComponent };